import './hero.css';
import Aretas from '../../img/ndimofor-aretas-portrait.png';
import { useContext } from 'react';
import { ThemeContext } from '../../context';

const Hero = () => {
	const theme = useContext(ThemeContext);
	return (
		<div className='hero'>
			<div className='hero-left'>
				<div className='hero-left-wrapper'>
					<h2 className='hero-intro'>Hellooo👋🏽, &nbsp; I'm </h2>
					<h1 className='hero-name'>Ndimofor Aretas</h1>
					<div className='hero-title'>
						<div className='hero-title-wrapper'>
							<div className='hero-title-item'>Full-stack Developer</div>
							<div className='hero-title-item'>Severless Developer</div>
							<div className='hero-title-item'>Technical Educator</div>
							<div className='hero-title-item'>Content Creator</div>
							<div className='hero-title-item'>React Developer</div>
						</div>
					</div>
					<p className='hero-description'>
						An outstanding STEM Educator with over 10 years of experience as an
						autodidact, IT Trainer, and web developer.
					</p>
				</div>
			</div>
			<div className='hero-right'>
				<div
					className='hero-right-bg'
					style={{ background: theme.state.darkMode && 'white' }}
				></div>
				<img
					src={Aretas}
					alt='Ndimofor Aretas Portrait'
					className='hero-img'
				/>
			</div>
		</div>
	);
};

export default Hero;
